import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';
import { MetricValueLockLevel, MetricValueLockOperation, useAddFeedbackMutation, useBatchLockImpactsMutation, useGetAccountQuery, useGetImpactQuery } from '~/types/types';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
import { getLocale } from '~/functions/translate';
import { resolveRequireImpactSubmission, useVentureId } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitWorkflow',
  setup: function setup(__props) {
    var route = useRoute();
    var ventureId = useVentureId();
    var impactId = computed(function () {
      return parseInt(route.params.impact, 10);
    });
    var router = useRouter();
    var locale = getLocale();
    var step = ref(1);
    var _useGetAccountQuery = useGetAccountQuery(),
      sessionAccountResult = _useGetAccountQuery.result;
    var _useGetAccountQuery2 = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      })),
      ventureAccountResult = _useGetAccountQuery2.result;
    var requiresImpactSubmission = computed(function () {
      var _sessionAccountResult, _ventureAccountResult;
      return resolveRequireImpactSubmission((_sessionAccountResult = sessionAccountResult.value) === null || _sessionAccountResult === void 0 ? void 0 : _sessionAccountResult.getAccount, (_ventureAccountResult = ventureAccountResult.value) === null || _ventureAccountResult === void 0 ? void 0 : _ventureAccountResult.getAccount);
    });
    var _useGetImpactQuery = useGetImpactQuery(computed(function () {
        return {
          impactId: impactId.value
        };
      })),
      impactResult = _useGetImpactQuery.result,
      refetch = _useGetImpactQuery.refetch;
    var impact = computed(function () {
      var _impactResult$value;
      return (_impactResult$value = impactResult.value) === null || _impactResult$value === void 0 ? void 0 : _impactResult$value.getImpact;
    });
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var impactEditable = computed(function () {
      return canEditImpact(impact.value, realUserIsIxAdmin.value);
    });
    var _useBatchLockImpactsM = useBatchLockImpactsMutation(),
      batchLockImpacts = _useBatchLockImpactsM.mutate,
      loading = _useBatchLockImpactsM.loading;
    var thanks = computed(function () {
      return locale === 'en' ? 'Thank you for your feedback!' : 'Vielen Dank fuer Ihr Feedback!';
    });
    var feedback = ref({
      title: 'Impact goal',
      rating: 0,
      description: '',
      url: route.fullPath,
      impactId: impactId.value
    });
    var _useAddFeedbackMutati = useAddFeedbackMutation(),
      addFeedback = _useAddFeedbackMutati.mutate;
    var submitImpact = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!requiresImpactSubmission.value || !impactEditable.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return batchLockImpacts({
                input: {
                  impactIds: [impactId.value],
                  operation: MetricValueLockOperation.Freeze,
                  lockingLevel: MetricValueLockLevel.Portfolio,
                  reason: 'Impact submitted by venture.'
                }
              });
            case 4:
              _context.next = 6;
              return refetch();
            case 6:
              step.value = 2;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submitImpact() {
        return _ref.apply(this, arguments);
      };
    }();
    var submitFeedback = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return addFeedback({
                payload: feedback.value
              }).then(function () {
                window.$nuxt.$emit('userMsg', {
                  color: 'green',
                  message: thanks.value
                });
                feedback.value = {
                  title: 'Impact goal',
                  description: '',
                  rating: 0,
                  url: route.fullPath
                };
                router.push("/".concat(route.params.venture, "/impact"));
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function submitFeedback() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      route: route,
      ventureId: ventureId,
      impactId: impactId,
      router: router,
      locale: locale,
      step: step,
      sessionAccountResult: sessionAccountResult,
      ventureAccountResult: ventureAccountResult,
      requiresImpactSubmission: requiresImpactSubmission,
      impactResult: impactResult,
      refetch: refetch,
      impact: impact,
      realUserIsIxAdmin: realUserIsIxAdmin,
      impactEditable: impactEditable,
      batchLockImpacts: batchLockImpacts,
      loading: loading,
      thanks: thanks,
      feedback: feedback,
      addFeedback: addFeedback,
      submitImpact: submitImpact,
      submitFeedback: submitFeedback
    };
  }
});